import * as React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Paper, Stack, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { ROOT, AUTHROOT } from '../../routes/CONSTANTS';
import { selectIsLoggedIn } from '../auth/UserSlice';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

const Item = styled(Paper)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingRight: theme.spacing(3),
  paddingLeft: theme.spacing(3),

  [theme.breakpoints.down('md')]: {
    paddingRight: 0,
    paddingLeft: theme.spacing(1),
  },
}));

export default function NavBar() {
  const loggedIn = useSelector(selectIsLoggedIn);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Item elevation={0} square>
        <Link to={loggedIn ? AUTHROOT : ROOT}>
          <img
            src={process.env.PUBLIC_URL + '/linktivity-logo-1.png'}
            alt='Linktivity Logo'
            style={{ height: 'auto', width: '50vw', maxWidth: '450px' }}
          />
        </Link>
      </Item>
      <Item elevation={0} square>
        {isMobile ? <MobileNav /> : <DesktopNav />}
      </Item>
    </Stack>
  );
}
